<template>
  <!--
      	作者：gmshop
      	时间：2020-06-01
      	描述：插件中心-服务-列表
      -->
  <div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="服务名称">
          <el-input v-model="formInline.name" placeholder="请输入服务名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addService" v-auth="'/service/service/add'">添加服务</el-button>
    </div>
    <div class="table-wrap">
      <el-table :data="tableData" style="width: 100%" ref="dragTable" v-loading="loading">
        <el-table-column prop="id" label="服务ID" width="60"></el-table-column>
        <el-table-column label="封面" width="50">
          <template slot-scope="scope">
            <img v-if="scope.row.image && scope.row.image.file_path" :src="scope.row.image.file_path" width="30" height="30" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称">
          <template slot-scope="scope">
            <div class="text-ellipsis" :title="scope.row.name">{{scope.row.name}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格" width="120"></el-table-column>
        <el-table-column prop="sort" label="排序" width="100"></el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" class="green">上架</span>
            <span v-if="scope.row.status == 0" class="gray">下架</span>
          </template>
        </el-table-column>
        <el-table-column prop="limit_total" label="限制总数" width="100"></el-table-column>
        <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="140"></el-table-column>
        <el-table-column prop="name" label="操作" width="90">
          <template slot-scope="scope">
            <el-button @click="editService(scope.row)" v-auth="'/service/service/edit'" type="text" size="small">编辑</el-button>
            <el-button @click="deleteService(scope.row)" v-auth="'/service/service/del'" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <div class="pagination">
        <el-pagination background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceApi from '@/api/service.js';
export default {
  data() {
    return {
      /*表单数据*/
      tableData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      formInline : {
        name: ''
      }
    };
  },
  created() {
    /*获取服务列表*/
    this.getTableList();
  },
  methods: {
    /*获取服务列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      ServiceApi.servicelist(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*查询*/
    search() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加服务*/
    addService() {
      this.$router.push('/service/service/add');
    },

    /*编辑服务*/
    editService(row) {
      let params = row.id;
      this.$router.push({
        path: '/service/service/edit',
        query: {
          id: params
        }
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getData();
    },

    /*删除服务*/
    deleteService(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          ServiceApi.del(
            {
              id: row.id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/service/service/index.vue